/* ### CONSTANTS ### */

import { IQueryMetaDataType } from '../../../../../boilerplate/redux/types/IQueryMetaDataType';
import { IApiErrorType } from '../../../../types/BaseTypes';

export const TAG_WIDGET_FETCH_ENTRIES = '@BasePipeline/tagWidgetReducer_FETCH_ENTRIES';
export const TAG_WIDGET_FETCH_ENTRY   = '@BasePipeline/tagWidgetReducer_FETCH_ENTRY';
export const TAG_WIDGET_ADD_ENTRIES = '@BasePipeline/tagWidgetReducer_ADD_ENTRIES';
export const TAG_WIDGET_ADD_ENTRY = '@BasePipeline/tagWidgetReducer_ADD_ENTRY';

export const TAG_WIDGET_SET_ERRORS   = '@BasePipeline/tagWidgetReducer_SET_ERRORS';

/* ### ACTIONS ### */

export function fetchTagWidgets (queryKey: string) {
	return {
		type: TAG_WIDGET_FETCH_ENTRIES,
		queryKey,
	};
}

export function addTagWidgetEntries (queryKey: string, entries: ITagWidgetType[], metaData?: IQueryMetaDataType , options?: IFetchOptionType) {
	return {
		type: TAG_WIDGET_ADD_ENTRIES,
		queryKey,
		entries,
		metaData,
		options
	};
}

export function addTagWidgetEntry (queryKey: string, entry: ITagWidgetType, metaData?: IQueryMetaDataType , options?: IFetchOptionType) {
	return {
		type: TAG_WIDGET_ADD_ENTRY,
		queryKey,
		entry,
		metaData,
	};
}

export function setTagWidgetErrors (queryKey: string, errors: IApiErrorType[], metaData?: IQueryMetaDataType , options?: IFetchOptionType) {
	return {
		type: TAG_WIDGET_SET_ERRORS,
		queryKey,
		errors,
		metaData,
	};
}
